import axios from "axios";

export const fetchDeleteUser = async (userId: string) => {
    return await axios.delete(`/api/user/${userId}`);
}